<div class="mb-5">
    <div class="accordion" id="accordion">
        <ngb-accordion activeIds="{{activeId}}" [closeOthers]="true"
            (panelChange)="changed($event)">
            <ngb-panel *ngFor="let criteria of criteriaList" [id]="'a'+criteria._id" title="{{criteria.EvaluationCriteria}}">
                <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="accordion-button card border-0 p-2">
                        <div class="row">
                            <div class="col-lg-10 d-flex align-items-center">
                                <span>{{criteria.EvaluationCriteria}}</span>
                            </div>
                            <div class="col-lg-2 d-flex align-items-center">
                                <span class="plus fa fa-plus pull-right" *ngIf="!criteria.isOpened"></span>
                                <span class="minus fa fa-minus pull-right" *ngIf="criteria.isOpened"></span>
                            </div>
                        </div>
                    </button>    
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="card-block">
                        <ul class="justify-content-center list-btn">
                            <li *ngFor="let question of criteria.EvaluationQuestion; let i = index;" (click)="selectedQues(question.EvaluationQuestionId._id)" style="cursor: pointer; text-align:center;">
                                <i *ngIf="question.EvaluationQuestionId.isActive" class="fa fa-caret-right keep-arrow-left"></i>
                                     <button class="btn btn-squared btn-sm mr-2 mb-2 btn-success"  [ngClass]="{ 'btn-danger' : showQuestionAnsweresStatus(question)}"
                                    type="button">{{i + 1 }}</button>
                            </li>
                        </ul>
                    </div>
                </ng-template>
            </ngb-panel>
        
            <ngb-panel [id]="commentPanel" id="commentPanel">
                <ng-template ngbPanelTitle >
                    <div>
                        Comments
                    </div>
                </ng-template>
                <ng-template ngbPanelContent>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>    
    </div>
</div>